/**
 * Expense categories supported by the app and ML categorization.
 * Must match ML service training labels.
 * Use getCategoryLabel(cat, t) to show localized name in the UI.
 */
export const EXPENSE_CATEGORIES = [
    "Groceries",
    "Restaurants",
    "Delivery",
    "Transport",
    "Travel",
    "Fees",
    "Subscriptions",
    "Ecommerce",
    "Retail",
    "Health",
    "Education",
    "Tools",
    "Office",
    "Home & Services",
    "Personal Care",
    "Services",
    "Entertainment",
    "Investments",
    "Taxes",
    "Adjustments",
    "Transfers",
    "Other",
] as const;

export type ExpenseCategory = (typeof EXPENSE_CATEGORIES)[number];

export function isExpenseCategory(value: string): value is ExpenseCategory {
    return EXPENSE_CATEGORIES.includes(value as ExpenseCategory);
}

/** i18n t function type (from useTranslation) */
type TFunction = (key: string) => string;

/**
 * Returns the localized label for a category. Use for display only; keep storing the English key.
 */
export function getCategoryLabel(category: string | undefined, t: TFunction): string {
    if (category == null || category.trim() === "") return t("analytics.uncategorized");
    if (isExpenseCategory(category)) return t(`categories.${category}`);
    return category;
}
